const ru = {
  login: {
    subtitle: 'Кабинет клиента',
    title: 'Вход',
    server: 'Сервер',
    serverPlaceholder: 'название-организации',
    checking: 'Проверка...',
    notFound: 'Организация не найдена',
    phone: 'Телефон',
    phonePlaceholder: '90 123 45 67',
    password: 'Пароль',
    submit: 'Войти',
    submitting: 'Вход...',
  },
  catalog: {
    searchPlaceholder: 'Поиск товара...',
    allFolders: 'Все',
    notFound: 'Не найдено',
    empty: 'Эта папка пуста',
    noPrice: 'Нет цены',
    addToCart: "Добавить",
    chooseUnit: "Выбрать единицу",
    selected: "выбрано",
    done: "Готово",
    doneRemovesAll: "Если поставить у всех 0, товар уберётся из корзины",
  },
  cart: {
    title: 'Корзина',
    empty: 'Корзина пуста',
    goCatalog: 'Перейти в каталог',
    myOrders: 'Мои заказы',
    notePlaceholder: 'Комментарий (необязательно)',
    total: 'Итого',
    submit: 'Оформить заказ',
    submitting: 'Отправка...',
    orderSent: 'Заказ №{number} отправлен',
    orderError: 'Ошибка при отправке заказа',
  },
  orders: {
    title: 'Мои заказы',
    empty: 'Пока нет заказов',
  },
  changePassword: {
    title: 'Установите новый пароль',
    hint: 'В целях безопасности необходимо изменить стандартный пароль. Это будет запрошено только один раз.',
    newPassword: 'Новый пароль',
    confirmPassword: 'Повторите новый пароль',
    tooShort: 'Пароль должен содержать минимум 4 символа',
    mismatch: 'Пароли не совпадают',
    submit: 'Сохранить',
    submitting: 'Сохранение...',
    success: 'Пароль обновлён',
    error: 'Произошла ошибка',
  },
  profile: {
    changePassword: "Сменить пароль",
    cancel: "Отмена",
  },
  home: {
    defaultTitle: 'Кабинет клиента',
    welcome: 'Добро пожаловать,',
    balance: 'Баланс',
    noBalance: 'Баланс отсутствует',
    weOwe: 'Мы вам должны',
    theyOwe: 'Задолженность',
    cashback: 'Кешбэк',
    cashbackProgramTitle: 'Программа кешбэка',
    cashbackProgramHint: 'Чем больше сумма покупки, тем выше процент возврата',
    cashbackCurrentTier: 'Сейчас вы на этом уровне',
    navHome: 'Главная',
    navCatalog: 'Каталог',
    navCart: 'Корзина',
    navAkt: 'Сверка',
    navProfile: 'Профиль',
    logout: 'Выйти',
  },
  aktSverka: {
    title: 'Акт сверки',
    period: 'Период',
    fromDate: 'С',
    toDate: 'По',
    youOwe: 'Ваш долг',
    theyOwe: 'Организация должна вам',
    noDebt: 'Задолженности нет',
    noTx: 'За этот период нет операций',
    opening: 'Начальный остаток',
    loadError: 'Ошибка загрузки',
    itemsEmpty: 'Состав отсутствует',
    total: 'Итого',
    close: 'Закрыть',
    share: 'Поделиться',
    shareTitle: 'Постоянная ссылка',
    shareHint: 'По этой ссылке/QR-коду можно в любое время посмотреть акт сверки — например, отправить бухгалтеру.',
    copy: 'Копировать',
    copied: 'Скопировано',
    qrDownload: 'Скачать',
    thDate: 'Дата', thDoc: 'Документ', thDebit: 'Дебет', thCredit: 'Кредит',
    pdfDownload: 'PDF',
  },
  uomNames: {
    pcs: "штука", kg: "килограмм", g: "грамм", t: "тонна", l: "литр", ml: "миллилитр",
    m: "метр", cm: "сантиметр", mm: "миллиметр", "m²": "квадратный метр", "m³": "кубометр", km: "километр",
    pair: "пара", roll: "рулон", box: "коробка", pack: "пачка", bag: "мешок", set: "комплект",
    bottle: "бутылка", can: "банка", cyl: "баллон", coil: "бухта", spool: "катушка", sheet: "лист", bunch: "пачка",
    hr: "час", min: "минута", day: "день", week: "неделя", month: "месяц", year: "год",
    visit: "визит", session: "сеанс", project: "проект", page: "страница", word: "слово", trip: "рейс",
  },
};
export default ru;
